export default "__VITE_ASSET__C$RG$9Jm__"